import { type FC, type ReactNode } from 'react';
import { Stack } from '@mui/material';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

export type MessagePageProps = {
  /**
   * Image to display at the top of the template.
   */
  image?: ReactNode;

  /**
   * Message to display below the image.
   */
  message?: ReactNode;

  /**
   * Action button to add new items.
   */
  action?: React.ReactNode;
};

export const MessagePage: FC<MessagePageProps> = ({
  image,
  message,
  action,
}) => (
  <CenteredLayout vertical horizontal>
    <Stack spacing={1} alignItems="center" justifyItems="center">
      {image}
      {message}
      {action}
    </Stack>
  </CenteredLayout>
);
